import styled from 'styled-components'

import { media, mediaMax } from 'styles/media'

import HorizontalList from './HorizontalList'
import Slider from './Slider'
import type { PositionProps } from './types'

const DesktopOnly = styled.div`
  ${mediaMax.md`
    display: none;
  `}
`

const MobileOnly = styled.div`
  ${media.md`
    display: none;
  `}

  width: 100%;
  overflow-x: scroll;
`

const Values = ({ desktopMarginTop = 56 }: PositionProps) => {
  return (
    <>
      <MobileOnly>
        <HorizontalList />
      </MobileOnly>

      <DesktopOnly>
        <Slider desktopMarginTop={desktopMarginTop} />
      </DesktopOnly>
    </>
  )
}

export default Values
